export enum AccountUserInviteStatusKind {
    PENDING = 0,
    DECLINED = 1,
    ACCEPTED = 2
}
